import moment from 'moment';

export default function formatScheduledDate(scheduledDate: string | null | undefined) {
  if (!scheduledDate) {
    return '';
  }
  const date = moment(scheduledDate);

  return date.format(`YYYY년 M월 D일 (ddd) HH시 mm분`);
}
